import moment from 'moment';

export const vat = [
  {'id': 1, 'value': 25},
  {'id': 2, 'value': 12},
  {'id': 3, 'value': 6},
  {'id': 4, 'value': 0}
];

export function getVatById (id) {
  for (let i = 0; i<vat.length; i++) {
    if (id === vat[i]['id']) {
      return vat[i]['value'];
    }
  }
}

export function reformatInputValue (amount) {
  amount = amount.replace(/ /g, '');
  amount = amount.replace(',', '.');
  if (amount.length === 0) amount = null;
  return amount;
}

export function hasExceededWorkingHours (dates) {
  for (var index = 0; index < dates.length; index++) {
    var untilDateRange;

    if (index < dates.length - 7) {
      untilDateRange = index + 7;
    } else {
      untilDateRange = dates.length;
    }

    const range = dates.slice(index, untilDateRange);
    const totalHours = getTotalHours(range);

    if (checkWorkingHoursInRange(range)) {
      return true;
    }

    if (totalHours >= 48) {
      for (var i = 0; i < untilDateRange; i++) {
        const dateRange = dates.slice(0, i + 1);
        if (checkWorkingHoursInRange(dateRange)) {
          return true;
        }
      }
    }
  }

  return false;
}

export function getTotalHours (range) {
  return range.reduce(
    (previousValue, date) => parseFloat(previousValue) + parseFloat(date.workHours),
    0,
  );
}

export function checkWorkingHoursInRange (range) {
  if (!range.length) {
    return false;
  }
  const withinSevenDayPeriod = isWithinSevenDayPeriod(
    range[0],
    range[range.length - 1]
  );

  const totalHours = getTotalHours(range);

  return totalHours >= 48 && withinSevenDayPeriod;
}

export function isWithinSevenDayPeriod (firstDate, secondDate) {
  const sixDaysInMilliseconds = 518400000;
  return moment(secondDate.displayDate).valueOf() - moment(firstDate.displayDate).valueOf() <= sixDaysInMilliseconds;
}



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoice-tool-helper.js
 **/